<template>

    <div class="dd-l-grid--opt-in">
        <h2 class="dd-l-grid--opt-in__title">Don't miss anything!</h2>

        <div class="dd-l-grid--opt-in__description">
            Assine nossa newsletter e fique por dentro de todos os lançamentos Avon e tenha acesso à conteúdos
            exclusivos!
        </div>

        <form v-on:submit.prevent="send()"
              novalidate
              class="dd-m-form dd-m-form--optin dd-m-form__col">
            <div class="dd-m-form__icon-input"
                 v-bind:class="{'has-error' : fields.email && !fields.email.valid && fields.email.touched,
                             'is-validated' : fields.email && fields.email.valid && fields.email.touched}">

                <input type="email"
                       name="email"
                       placeholder="E-mail"
                       v-model="email"
                       v-validate="'required|email'"
                       class="dd-m-form__input dd-m-form__input--bordered"/>

                <vue-ladda button-class="dd-m-button dd-m-button--assertive dd-m-button--tiny dd-m-helper--centralize"
                           :loading="isLoading"
                           data-style="zoom-in">
                    <i class="dd-m-icon icon-send"></i>
                </vue-ladda>

                <div class="dd-m-form__error-msg" v-if="errors.length">
                    <span v-for="(error, index) in errors" :key="index">
                        {{error}}
                    </span>
                </div>
            </div>
        </form>
    </div>

</template>
<script>
    import NewsletterService from '../../providers/api/newsletter-service';

    const newsletterService = new NewsletterService();

    export default {
        name: 'opt-in-subscribe',
        data: () => {
            return {
                email: null,
                errors: [],
                isLoading: false
            }
        },
        mounted() {
        },
        methods: {
            send() {
                if (this.email && this.fields.email.valid) {
                    this.isLoading = true;
                    this.errors = [];
                    newsletterService.doSubscribe(this.email)
                        .then(() => {
                            PubSub.publish('updateCustomNewsletterModalStep', {step: 2});
                            this.isLoading = false;
                        })
                        .catch((err) => {
                            this.errors = [err.response.message];
                            this.isLoading = false;
                        });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/opt-in/opt-in-subscribe.vue